import { Meta } from "@/shared/components";
import { BillingExpenses } from "@/admin/features/billing";

export function BillingExpensesPage() {
  return (
    <>
      <Meta title="Наши траты" />
      <BillingExpenses />
    </>
  );
}
